import { z } from 'zod'

import { zFavoriteMultipleListItem } from '@/schemas/favoriteMultipleListItemSchema'
import { zPagination } from '@/schemas/paginationSchema'

export const zFavoriteMultipleListResponse = z.object({
  results: z.array(zFavoriteMultipleListItem),
  pagination: z.optional(zPagination),
})

export type FavoriteMultipleListResponseSchema = z.infer<typeof zFavoriteMultipleListResponse>
